module.exports = require("@wallaby-ui/merie/src/js/mocks/feature/hospitalization_detail/hospitalization_timeline_data_mock.json");